import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApiData } from './contexts/ApiContext';
import ErrorBoundary from './component/errorBoundary/ErrorBoundary';
import App from './App';

const WHATSAPP_URL = 'https://wa.me/+5491121557430?text=Hola%20como%20estas?%20deseo%20información%20o%20servicio%20técnico%20para%20mi%20equipo.%20Gracias!';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <ApiData>
        {/* <a> y no <Link>: es un dominio externo, no una ruta del router */}
        <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Contactar por WhatsApp">
          <div style={{
            backgroundImage: `url('/assets/img/whatsapp.svg')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: 'fit-content',
            position: 'fixed',
            bottom: '30px',
            right: '20px',
            padding: '30px',
            zIndex: '999'
          }}>
          </div>
        </a>
        <App />
      </ApiData>
    </BrowserRouter>
  </ErrorBoundary>
);
